/* Component-owned transparent header; rebind safely after editor replacements. */
(() => {
  let cleanup = () => {};
  function initialize() {
    cleanup();
    const body = document.body;
    const wrapper = document.querySelector('.header-wrapper[data-transparent-enabled]');
    const enabled = wrapper?.dataset.transparentEnabled === 'true';
    body.classList.toggle('header-transparent', enabled);
    body.classList.toggle('header-overlay-text-dark', enabled && wrapper.dataset.transparentText === 'dark');
    body.style.setProperty('--transparent-header-scrim', wrapper?.dataset.transparentScrim || '0');
    body.classList.remove('header-is-solid');
    if (!enabled) {
      document.documentElement.style.setProperty('--transparent-header-offset', '0px');
      return;
    }
    const threshold = Number(wrapper.dataset.transparentThreshold) || 0;
    const state = { scrolled: window.scrollY > threshold, hovered: false, menuOpen: false };
    const listeners = [];
    let active = true, ticking = false, observer;
    const listen = (target, type, handler, options) => {
      target.addEventListener(type, handler, options);
      listeners.push(() => target.removeEventListener(type, handler, options));
    };
    const apply = () => { if (active) body.classList.toggle('header-is-solid', state.scrolled || state.hovered || state.menuOpen); };
    const setOffset = () => {
      if (!active) return;
      let total = 0;
      document.querySelectorAll('.shopify-section-group-header-group').forEach(group => {
        if (!group.querySelector('.utility-bar--solid')) total += group.offsetHeight;
      });
      document.documentElement.style.setProperty('--transparent-header-offset', `${total}px`);
    };
    listen(window, 'scroll', () => {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(() => { state.scrolled = window.scrollY > threshold; apply(); ticking = false; });
    }, { passive: true });
    listen(window, 'resize', setOffset);
    listen(window, 'load', setOffset);
    if ('ResizeObserver' in window) {
      observer = new ResizeObserver(setOffset);
      document.querySelectorAll('.shopify-section-group-header-group').forEach(group => observer.observe(group));
    }
    document.fonts?.ready.then(setOffset);
    if (wrapper.dataset.transparentHover === 'true') {
      const enter = () => { state.hovered = true; apply(); };
      const leave = () => { state.hovered = false; apply(); };
      listen(wrapper, 'mouseenter', enter);
      listen(wrapper, 'mouseleave', leave);
      listen(wrapper, 'focusin', enter);
      listen(wrapper, 'focusout', event => { if (!wrapper.contains(event.relatedTarget)) leave(); });
    }
    const disclosures = Array.from(wrapper.querySelectorAll('details'));
    disclosures.forEach(detail => listen(detail, 'toggle', () => {
      state.menuOpen = disclosures.some(item => item.open); apply();
    }));
    cleanup = () => { active = false; observer?.disconnect(); listeners.forEach(remove => remove()); };
    setOffset(); apply();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.querySelector?.('.header-wrapper')) { cleanup(); document.body.classList.remove('header-transparent', 'header-is-solid'); }
  });
})();
